<template>
  <div>
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
      <v-card>
        <v-card-title class="admin white--text text-uppercase dialog-title ">
          Xác nhận thông tin khách hàng
          <v-spacer></v-spacer>
          <v-btn dark icon>
            <v-icon @click="cancel" class="mr-n1" :disabled="loading">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-0">
          <ConfirmLeadTable :documents="importedDocuments" :isImportPreview="true" />
        </v-card-text>
        <v-card-actions class="pa-6">
          <v-btn color="primary" @click="cancel" width="118" :loading="loading" large outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="confirmDialog = true"
            :loading="loading"
            width="118"
            class="white--text elevation-0"
            large
            >Xác nhận</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDialog" persistent max-width="420px">
      <v-card>
        <v-card-title class="headline">Xác nhận thông tin khách hàng</v-card-title>
        <v-card-text>
          Hãy kiểm tra thật kỹ thông tin của khách hàng.
          <v-text-field v-model="importOrigin" label="Nguồn marketing" placeholder="Nguồn marketing"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-4" text @click="confirmDialog = false" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="confirm">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConfirmLeadTable from './ConfirmLeadTable'
export default {
  props: {
    importedDocuments: Array,
    state: Boolean,
    currentNumber: Number,
    totalNumber: Number
  },
  components: {
    ConfirmLeadTable
  },
  computed: {},
  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      confirmDialog: false,
      importOrigin: ''
    }
  },
  methods: {
    cancel() {
      this.$emit('closeDialog')
    },
    async confirm() {
      this.loading = true
      this.confirmDialog = false
      if (this.importOrigin.trim() !== '') {
        const updatedDocuments = this.importedDocuments.map(document => {
          return {...document, importOrigin: this.importOrigin}
        })
        this.$emit('updateResult', updatedDocuments)
      } else {
        this.$emit('updateResult', this.importedDocuments)
      }
    }
  }
}
</script>

<style scoped>
.card-title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
}
.card-content {
  text-align: justify !important;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: normal;
  font-size: 14px !important;
  line-height: 20px;
  color: #3e3e3c !important;
}
.btn {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px !important;
  line-height: 20px;
}
</style>
